import Header from "@/Components/Header/";
import CenterLoader from "@/Components/Loaders/CenterLoader";

import { usePage } from "@inertiajs/react";
import { useState } from "react";

export default function AuthenticatedLayout({
    header,
    children,
    scrollable = true,
}) {
    // const user = usePage().props.auth.user;
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="dark:bg-boxdark-2 dark:text-bodydark">
            {/* Page Wrapper */}
            <div
                className={`h-screen ${
                    scrollable ? "overflow-auto" : "overflow-hidden"
                }`}
            >
                {/* Sidebar could go here if needed */}

                {/* Content Area */}
                <div className="relative flex flex-1 flex-col">
                    {/* Header */}
                    <Header
                        sidebarOpen={sidebarOpen}
                        setSidebarOpen={setSidebarOpen}
                    />

                    {/* Main Content */}
                    <main>
                        <div>{children}</div>
                    </main>
                </div>
            </div>
            <CenterLoader />
        </div>
    );
}
